import type { UseQueryOptions } from '@tanstack/react-query';
import type { AccessLevel } from '../types';
import { useQuery } from '@tanstack/react-query';
import UsersApi from '~/agent/users';

export function getUserAccessLevel(userId: number, folderId: string): Promise<AccessLevel[]> {
  return UsersApi.user.isLimitedEditorOfFolder({ userId, folderId });
}

export function useGetUserAccessLevel(
  folderId: string,
  queryOptions: UseQueryOptions<AccessLevel[], JQuery.jqXHR> = {},
  userId: number = window.getCurrentUser().id,
) {
  return useQuery<AccessLevel[], JQuery.jqXHR>(
    ['user_access', userId, folderId],
    () => getUserAccessLevel(userId, folderId),
    queryOptions,
  );
}
